<template>
    <div class="wrap clearfix">
        <h2>조제 특이사항</h2>
        <div class="btn-group clearfix">
            <!-- <p class="cnt-group">건수 : {{ total_count }}</p>  -->
        </div>
        <div class="clearfix">
            <div class="left">
                <ConsultMemoList @onSelectRow="onSelectRow"></ConsultMemoList>
            </div>
            <div class="right">
                <div class="box">
                    <ConsultMemoContent :current_memo="current_memo"></ConsultMemoContent>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import ConsultMemoList from '@/components/ConsultMemo/ConsultMemoList.vue'
    import ConsultMemoContent from '@/components/ConsultMemo/ConsultMemoContent.vue'

    export default {
        name: 'consult-memo',
        data() {
            return {
                current_memo: {}, //선택한 row의 memo_id, list에서 받아옴?
                bootstrapPaginationClasses: {
                    ul: 'pagination',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                customLabels: {
                    first: 'First',
                    prev: 'Previous',
                    next: 'Next',
                    last: 'Last'
                }
            }
        },
        computed: {
            ...mapState(['account'])
        },
        methods: {
            async onSelectRow (memo){
                this.current_memo = memo;
            },
        },
        mounted() {
        
        },
        components: {
            ConsultMemoList, ConsultMemoContent
        }
    }

</script>

<style scoped>
    .wrap {
        width: 100%;
        max-width: 1160px;
        margin: 40px auto 40px;
    }

    .wrap h2 {
        margin-bottom: 10px;
        font: 400 24px 'Noto Sans KR', sans-serif;
    }

    .btn-group {
        width: 635px;
        margin-bottom: 15px;
    }

    .btn-group .cnt-group {
        color: #999;
        float: right;
        margin-top: 10px;
        margin-right: 5px;
        display: block;
    }

    .left, .right {
        border: 1px solid #e7e7e9;
        box-sizing: border-box;
        background-color: #fff;
    }

    .left {
        width: 630px;
        height: 690px;
        float: left;
        margin-right: 10px;
        position: relative;
    }

    .right {
        width: 514px;
        float: left;
    }

    .right .box {
        width: 100%;
        height: 690px;
        padding: 30px 30px 0;
        overflow-y: scroll;
        position: relative;
        box-sizing: border-box;
    }
</style>
